import React, {useState} from "react";
import DevNavSection from "../DevNavSection";
import {useVaultDispatch} from "../../top/VaultContext";
import {useVaultUpdate} from "../../util/useVaultUpdate";
import AT from "../../vault/ActionTypes";

export const DevAccountTools = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [message, setMessage] = useState("");
	const dispatch = useVaultDispatch();
	const handleAddStudent = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsLoading(true);
		const formData = new FormData(e.target as HTMLFormElement);
		const planType = formData.get("planType") as string;
		const studentName = formData.get("studentName") as string;
		const bypassMaxSubscriptions = formData.get("bypassMaxSubscriptions");
		dispatch({
			type: AT.DEV_ADD_NEW_STUDENT_REQUEST,
			payload: {
				planType,
				studentName,
				bypassMaxSubscriptions: bypassMaxSubscriptions === "on",
			},
		});
	};

	const students = useVaultUpdate<any[]>({
		getValuesFromVault: vaultState => vaultState.user?.model?.students,
		eventHandlers: {
			devAddNewStudentSuccess: () => {
				setIsLoading(false);
				window.location.reload();
			},
			devAddNewStudentFail: () => {
				setIsLoading(false);
				setMessage("Failed to add student");
			},
		},
	});

	return (
		<DevNavSection heading="Account Tools">
			<div>
				Add Student
				<p style={{fontSize: "1rem", margin: 0}}>
					Note: This only works on existing parent accounts
				</p>
				<form
					onSubmit={handleAddStudent}
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "1rem",
						margin: "1.5rem 0",
					}}
				>
					<section
						style={{
							display: "flex",
							alignItems: "stretch",
							alignSelf: "stretch",
						}}
					>
						<select defaultValue="monthly" name="planType">
							<option value="monthly">Monthly</option>
							<option value="yearly">Yearly</option>
						</select>
						<input
							type="text"
							name="studentName"
							placeholder="Student Name"
							aria-label="Student Name"
							style={{
								flex: 1,
							}}
						/>
					</section>
					<label style={{display: "flex", gap: ".5rem"}}>
						<input
							type="checkbox"
							name="bypassMaxSubscriptions"
							defaultChecked
						/>
						<div style={{display: "flex", flexDirection: "column"}}>
							<p style={{margin: 0}}> Bypass Max Subscriptions </p>
							<p style={{fontSize: "1rem", margin: 0}}>
								(Current Count: {students?.length ?? 0})
							</p>
						</div>
					</label>
					<button type="submit" disabled={isLoading}>
						{isLoading ? "Adding Student..." : "Add Student"}
					</button>
					{message && (
						<p style={{color: "slateblue", margin: 0, textAlign: "center"}}>
							{message}
						</p>
					)}
				</form>
			</div>
		</DevNavSection>
	);
};
